module.exports = __webpack_public_path__ + "static/media/icomoon.7a375c43.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/fonts/icomoon.woff
// module id = 1448
// module chunks = 1